const WEBSITE_URL_HTML_PATTERN =
  "^\\s*(([Hh][Tt][Tt][Pp][Ss]?://)?([\\p{L}\\p{N}]([\\p{L}\\p{N}\\-]{0,61}[\\p{L}\\p{N}])?\\.)+\\p{L}{2,}(:\\d{1,5})?([\\/?#]\\S*)?)?\\s*$";

const WEBSITE_URL_PATTERN = new RegExp(WEBSITE_URL_HTML_PATTERN, "u");

class WebsiteUrlFormatService {
  static isValid(value) {
    if (value === undefined || value === null) return true;
    const url = String(value).trim();
    if (!url) return true;
    return WEBSITE_URL_PATTERN.test(url);
  }
}

WebsiteUrlFormatService.HTML_PATTERN = WEBSITE_URL_HTML_PATTERN;

export default WebsiteUrlFormatService;
